import React from 'react'
import GenerateIcon from '../../components/GenerateIcon'
import { Link } from 'react-router-dom'

export default function DocumentationLink() {

    let url: string = "https://www.notion.so/Miraj-Inventory-Documentation-1d315df85b0f8005bd47d32387194f46?pvs=4"

    return(
        <div className="wrapper-of-documentation-link-box">
            <Link to={url} target="_blank">
                <div className="documentation-link-box">
                    <div className="content-of-documentation-link-box">
                        <GenerateIcon icon="document" />
                        <h3>Inventory Documentation</h3>
                    </div>
                </div>
            </Link>
        </div>
    )
}